import _ from "lodash";
import GlobalConfig from "@src/GlobalConfig";
import { ReactComponent as StrokeWidth } from "./svgs/strokeWidth.svg";

const NavWrap = (props: any) => {
  const {
    activeNav,
    handleNavigate,
    handleNavAnchor,
    handleChevron,
    item,
    activeLabel,
    activeLabelNotStroke,
  } = props;

  return item.showFlexGroupStrokeWidth ? (
    <div className="flex h-full">
      <div
        id="navContentWrap"
        className={`navWrap flex ${item.noNextLevel ? "flex-col" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {item.content.map((navContent: any, index: number) => {
          return (
            <div className="navContent" key={index}>
              {navContent.title && (
                <>
                  <nav
                    className={`navTitle cursor-pointer ${
                      navContent.noNextLevel ? "navBlackTitle" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (navContent.link) {
                        window.open(navContent.link, "_blank");
                      } else if (navContent?.path === "develop") {
                        GlobalConfig.pushOpenAPI();
                      } else {
                        handleNavigate(navContent);
                        handleChevron(item.key, "down");
                      }
                    }}
                  >
                    {navContent.title}
                  </nav>
                  <StrokeWidth />
                </>
              )}
              <div className="navLabelWrap">
                {navContent?.list?.map((nav: any, idx: number) => {
                  return (
                    <nav
                      className={`flex items-center navLabel cursor-pointer ${
                        activeLabel === nav.key ? "activeNavOrLabel" : ""
                      }`}
                      key={idx}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNavAnchor(navContent.path, nav.anchor, nav.type);
                        handleChevron(item.key, "down");
                      }}
                    >
                      {nav.icon}
                      {nav.label}
                    </nav>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <div className="flex h-full">
      <div
        id="navContentWrap"
        className={`navWrap flex ${item.noNextLevel ? "flex-col" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="flex">
          {item.content.map((navContent: any, index: number) => {
            return (
              <div className="navContent" key={index}>
                {navContent.title && (
                  <>
                    <nav
                      className={`navTitleNotStoke cursor-pointer ${
                        navContent.noNextLevel ? "navBlackTitle" : ""
                      }`}
                    >
                      {navContent.title}
                    </nav>
                  </>
                )}
                <div className="navLabelWrap flex">
                  {navContent?.list?.map((nav: any, idx: number) => {
                    return (
                      <nav
                        className={`flex items-center navLabel cursor-pointer ${
                          activeLabelNotStroke === nav.path ? "activeNavOrLabel" : ""
                        }`}
                        key={idx}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (nav.link) {
                            window.open(nav.link, "_blank");
                          } else if (nav?.path === "develop") {
                            GlobalConfig.pushOpenAPI();
                          } else {
                            handleNavigate(nav);
                            handleChevron(navContent.key, "down");
                          }
                        }}
                      >
                        {nav.icon}
                        {nav.label}
                      </nav>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default NavWrap;
